import {useState, useEffect, useMemo, useCallback} from 'react';
import {useHistory} from 'react-router-dom';
import {useAppSelector, useAppDispatch} from '../../store/hooks';
import {setActiveTenant} from '../../store/permissions/permissions.slice';
import AutocompleteInput from '../common/formik/inputs/AutocompleteInput';

const minNumberOfTenantsToEnableSwitch = 2;

const Tenants = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const {availableTenants} = useAppSelector(({permissions}) => permissions);
  const {activeTenant} = useAppSelector(({permissions}) => permissions);

  const options = useMemo(() => availableTenants.map(({slug, name}) => ({
    value: slug,
    label: name
  })), [availableTenants]);

  const [inputValue, setInputValue] = useState<string>('');
  const [value, setValue] = useState<Nullable<string>>(null);

  useEffect(() => {
    if (!value) {
      const currentTenant =
        options?.find((option) => option?.value === activeTenant);

      setValue(currentTenant?.value || null);
    }
  }, [activeTenant, options]);

  const handleSelectChange = useCallback((_, newValue) => {
    const {value} = newValue || {};

    history.push('/');
    dispatch(setActiveTenant(value));
    setValue(value);
  }, []);

  const handleInputChange = useCallback((_, newValue) =>
    setInputValue(newValue),
  []
  );

  const isDisabled =
    availableTenants?.length < minNumberOfTenantsToEnableSwitch;

  if (!availableTenants?.length) {
    return null;
  }

  return (
    <AutocompleteInput
      id="tenant"
      name="tenant"
      size="small"
      value={value}
      inputValue={inputValue}
      options={options}
      disabled={isDisabled}
      disableClearable
      onChange={handleSelectChange}
      onInputChange={handleInputChange}
      className="tenant-selector"
    />
  );
};

export default Tenants;
